/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PostVideoCompleteMultiPartUploadRequestPartsInner } from './PostVideoCompleteMultiPartUploadRequestPartsInner';
import {
    PostVideoCompleteMultiPartUploadRequestPartsInnerFromJSON,
    PostVideoCompleteMultiPartUploadRequestPartsInnerFromJSONTyped,
    PostVideoCompleteMultiPartUploadRequestPartsInnerToJSON,
} from './PostVideoCompleteMultiPartUploadRequestPartsInner';

/**
 * 
 * @export
 * @interface PostVideoCompleteMultiPartUploadRequest
 */
export interface PostVideoCompleteMultiPartUploadRequest {
    /**
     * 
     * @type {string}
     * @memberof PostVideoCompleteMultiPartUploadRequest
     */
    uploadId: string;
    /**
     * 
     * @type {string}
     * @memberof PostVideoCompleteMultiPartUploadRequest
     */
    fileName: string;
    /**
     * 
     * @type {Array<PostVideoCompleteMultiPartUploadRequestPartsInner>}
     * @memberof PostVideoCompleteMultiPartUploadRequest
     */
    parts: Array<PostVideoCompleteMultiPartUploadRequestPartsInner>;
}

/**
 * Check if a given object implements the PostVideoCompleteMultiPartUploadRequest interface.
 */
export function instanceOfPostVideoCompleteMultiPartUploadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "uploadId" in value;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "parts" in value;

    return isInstance;
}

export function PostVideoCompleteMultiPartUploadRequestFromJSON(json: any): PostVideoCompleteMultiPartUploadRequest {
    return PostVideoCompleteMultiPartUploadRequestFromJSONTyped(json, false);
}

export function PostVideoCompleteMultiPartUploadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostVideoCompleteMultiPartUploadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uploadId': json['uploadId'],
        'fileName': json['fileName'],
        'parts': ((json['parts'] as Array<any>).map(PostVideoCompleteMultiPartUploadRequestPartsInnerFromJSON)),
    };
}

export function PostVideoCompleteMultiPartUploadRequestToJSON(value?: PostVideoCompleteMultiPartUploadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uploadId': value.uploadId,
        'fileName': value.fileName,
        'parts': ((value.parts as Array<any>).map(PostVideoCompleteMultiPartUploadRequestPartsInnerToJSON)),
    };
}

